<template>
  <div class="tag">
    <!-- <div
      style="display: flex; flex-wrap: wrap; width: 467px"
      v-for="(item, index) in tagList"
      :key="item.id"
    > -->
    <div style="display: flex; flex-wrap: wrap; width: 467px">
      <div class="tag-add" @click="showDialog" v-if="!onlineVersion">
        <img class="tag-add-img" src="@/img/add.png" />
        <span> {{ $t("foundgame.tag.add") }}</span>
      </div>
      <div class="tag-add2" v-else></div>

      <template v-for="(item, index) in tagList">
        <div
          class="child-tag"
          v-for="childItem in item.children"
          :key="childItem.id"
          v-if="tagId.includes(childItem.id)"
        >
          <span> {{ childItem.name }}</span>
          <div class="tag-close" @click="deleteTag(childItem)">
            <img
              class="tag-close-img"
              src="@/img/close.png"
              v-if="!onlineVersion"
            />
          </div>
        </div>
      </template>
    </div>

    <!-- </div> -->
    <el-dialog
      :title="$t('foundgame.tag.title')"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="800px"
    >
      <div class="tag-box">
        <div
          v-for="item in tagList"
          v-if="item.children && item.children.length > 0"
        >
          <div class="tag-box-item">
            <div class="tag-box-item-left">
              <div class="tag-box-item-left-name">{{ item.name }}</div>
            </div>
            <div class="tag-box-item-right">
              <div
                v-for="tag in item.children"
                class="children"
                @click="selectTag(tag)"
                :id="tag.id"
              >
                <div class="children-name">{{ tag.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogClose">
          {{ $t("foundgame.tag.confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false, // 对话框是否可见
      tagId: [],
      tagCode: [],
      onlineVersion: null,
    };
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
    tagList: [],
  },
  created() {
    if (this.defaultValue) {
      console.log("this.defaultValue", this.defaultValue);
      this.tagId = this.defaultValue.tagId; // 设置默认值
      this.tagCode = this.defaultValue.tagCode; // 设置默认值
      this.onlineVersion = this.defaultValue.onlineVersion;
    }
  },
  mounted() {},
  updated() {
    this.$nextTick(() => {
      if (this.tagId.length > 0) {
        const childrenElems = this.$el.querySelectorAll(".children");
        childrenElems.forEach((elem) => {
          if (this.tagId.includes(elem.id)) {
            elem.classList.add("selected");
          }
        });
      }
    });
  },

  methods: {
    selectTag(tag) {
      // 检查是否已选择该标签
      const index = this.tagId.indexOf(tag.id);
      console.log("index", index);
      if (index === -1) {
        this.tagCode.push(tag.code);
        this.tagId.push(tag.id);

        // 为选中的标签添加蓝色边框
        const childrenElems = this.$el.querySelectorAll(".children");
        childrenElems.forEach((elem) => {
          if (elem.id === tag.id) {
            elem.classList.add("selected");
          }
        });
      } else {
        this.tagCode.splice(index, 1);
        this.tagId.splice(index, 1);

        // 移除选中的标签的蓝色边框
        const childrenElems = this.$el.querySelectorAll(".children");
        childrenElems.forEach((elem) => {
          if (elem.id === tag.id) {
            elem.classList.remove("selected");
          }
        });
      }
    },
    deleteTag(tag) {
      // 检查是否已选择该标签
      const index = this.tagId.indexOf(tag.id);
      this.tagCode.splice(index, 1);
      this.tagId.splice(index, 1);
      const childrenElems = this.$el.querySelectorAll(".children");
      childrenElems.forEach((elem) => {
        if (elem.id === tag.id) {
          elem.classList.remove("selected");
        }
      });
    },
    showDialog() {
      // 打开对话框
      this.dialogVisible = true;
    },
    handleDialogClose() {
      // 关闭对话框
      this.dialogVisible = false;
      console.log("this.tagId", this.tagId);
      this.$emit("close", { tagId: this.tagId, tagCode: this.tagCode }); // 触发 close 事件并传递选中的值
    },
  },
};
</script>

<style scoped="scoped">
.el-dialog {
  max-width: 800px !important;
}
.tag {
  display: flex;
  flex-wrap: wrap;
}
.tag-add {
  margin-top: 5px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  border: dashed 1px #4990fa;
  cursor: pointer;
  margin-right: 7px;
  color: #4990fa;
}
.tag-add2 {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tag-add-img {
  width: 13px;
  height: 12px;
  margin-right: 8px;
}
.tag-box {
  height: 500px;
  margin: 0 auto;
  width: 712px;
  overflow: auto;
}
.tag-box-item {
  display: flex;
}
.tag-box-item-left {
  width: 80px;
}
.tag-box-item-left-name {
  font-size: 14px;
  line-height: 30px;
  color: #282828;
}
.tag-box-item-right {
  width: 632px;
  display: flex;
  flex-wrap: wrap;
}
.children {
  cursor: pointer;
  position: relative;
  border-radius: 4px;
  border: solid 1px #dddddd;
  min-width: 81px;
  margin: 0 9px 9px 0;
  height: 30px;
  text-align: center;
  padding: 0 12px;
}
.children-name {
  font-size: 14px;
  line-height: 30px;
  color: #666666;
}
.selected {
  border: solid 1px #4990fa;
  background-color: #f2f7ff;
}
.selected .children-name {
  color: #4990fa;
}
.children.selected::after {
  content: "";
  position: absolute;
  top: -1px;
  right: -1px;
  background-image: url("~@/img/choose.png");
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.child-tag {
  margin-top: 5px;
  height: 30px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 0 16px;
  border-radius: 4px;
  border: solid 1px #dddddd;
  margin-right: 7px;
  line-height: 30px;
  background-color: #fafafa;
}
.tag-close {
  flex-grow: 1;
  cursor: pointer;
  padding-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.tag-close-img {
  width: 8px;
  height: 8px;
  margin-left: 7px;
}
</style>

<style>
.el-dialog__footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/games/TagDialog.vue